const key = 'timetask:pending-subscription-payment';
const maxAgeMs = 24 * 60 * 60 * 1000;

export function isValidPaymentOrderId(value: string): boolean {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value)
        && value !== '00000000-0000-0000-0000-000000000000';
}

type PendingPayment = { orderId: string; userId: string; createdAt: number };

export function readPendingSubscriptionPayment(): PendingPayment | null {
    try {
        const item = JSON.parse(sessionStorage.getItem(key) ?? 'null');
        if (!item || typeof item.orderId !== 'string' || !isValidPaymentOrderId(item.orderId)
            || typeof item.userId !== 'string' || !item.userId || !Number.isFinite(item.createdAt)
            || item.createdAt > Date.now() + 60000 || Date.now() - item.createdAt > maxAgeMs) return null;
        return item;
    } catch { return null; }
}

// Called by checkout before redirecting to confirmationUrl. No credentials are stored.
export function rememberPendingSubscriptionPayment(orderId: string, userId: string): boolean {
    if (!isValidPaymentOrderId(orderId) || !userId) return false;
    try {
        const existing = readPendingSubscriptionPayment();
        const createdAt = existing?.orderId === orderId.toLowerCase() && existing.userId === userId
            ? existing.createdAt : Date.now();
        sessionStorage.setItem(key, JSON.stringify({ orderId: orderId.toLowerCase(), userId, createdAt }));
        return true;
    } catch { return false; }
}

export function forgetPendingSubscriptionPayment(orderId: string, userId: string): void {
    const existing = readPendingSubscriptionPayment();
    if (existing?.orderId !== orderId.toLowerCase() || existing.userId !== userId) return;
    try { sessionStorage.removeItem(key); } catch { /* Storage may be disabled. */ }
}
